import { FunctionComponent } from 'react';

import { Field, Widget } from '@kanda-libs/ks-component-ts';

import SatNoteAddressFields from './AddressFIelds';
import {
  COMPLETE_INPUT_VALIDATION,
  COMPLETE_SUPPLY_PROPS,
  INPUT_PROPS,
  SUPPLY_PROPS,
} from './constants';

const SatNoteFormQuestionsSupplyOnly: FunctionComponent = () => (
  <>
    <Field.Validator validation={COMPLETE_INPUT_VALIDATION}>
      <Field.Select {...COMPLETE_SUPPLY_PROPS} />
    </Field.Validator>
    <Widget.JobSatNoteQPressure {...INPUT_PROPS} {...SUPPLY_PROPS.pressure} />
    <Widget.JobSatNoteQEasiness {...INPUT_PROPS} />
    <Widget.JobSatNoteQAvailability
      {...INPUT_PROPS}
      {...SUPPLY_PROPS.availability}
    />
    <Widget.JobSatNoteQApplication {...INPUT_PROPS} />
    <Widget.JobSatNoteQAdvice {...INPUT_PROPS} {...SUPPLY_PROPS.advice} />
    <Widget.JobSatNoteQRate {...INPUT_PROPS} {...SUPPLY_PROPS.rate} />
    <SatNoteAddressFields />
    <Field.FingerprintBooleanInput
      handle="checkbox"
      name="acknowledged"
      fieldText="I acknowledge that by clicking the submit button I agree the goods has been delivered satisfactorily"
    />
  </>
);

export default SatNoteFormQuestionsSupplyOnly;
